/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { store } from "@/main";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export const attachmentWot = async (
  file,
  resourceName,
  resourceValue,
  attachmentTypeName,
  attachmentTypeId,
  caption = null,
  progress = () => {}
) => {
  try {
    const url = generateApiUrl(
      ["globalServices", "attachment_wot"],
      [resourceName, resourceValue]
    );
    const headers = { "Content-Type": "multipart/form-data" };
    const payload = new FormData();
    payload.append("file", file);
    payload.append("caption", caption);
    payload.append("attachment_type_id", attachmentTypeId);
    payload.append("attachment_type_name", attachmentTypeName);
    const response = await httpService.post(
      url,
      payload,
      headers,
      true,
      progress
    );
    return {
      message: pathOr(null, ["data", "message"], response),
    };
  } catch (error) {
    throw error;
  }
};

export const attachmentTemp = async (file, progress = () => {}) => {
  try {
    const url = generateApiUrl(["globalServices", "attachment_temp"]);
    const headers = { "Content-Type": "multipart/form-data" };
    const payload = new FormData();
    payload.append("image", file);
    const response = await httpService.post(
      url,
      payload,
      headers,
      true,
      progress
    );
    const data = pathOr(null, ["data", "data"], response);
    return { code: pathOr(null, ["code"], data) };
  } catch (error) {
    throw error;
  }
};
export const attachmentResource = async (
  url,
  tempFiles,
  extraPayload = null
) => {
  try {
    const payload = {
      files: tempFiles,
      ...extraPayload,
    };
    const response = await httpService.post(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const getAttachmentFiles = async (
  routePath,
  resourceName,
  resourceValue,
  queryString = null,
  queryStringWithKeysRepeat = null
) => {
  try {
    let url = generateApiUrl(
      ["globalServices", "attachment_files"],
      [routePath, resourceName, resourceValue],
      queryString
    );
    if (queryStringWithKeysRepeat) {
      // merged keys repeat of query string with url
      const extraQueryString = Object.keys(queryString).length
        ? queryStringWithKeysRepeat.replace("?", "&")
        : queryStringWithKeysRepeat;
      url = url + extraQueryString;
    }
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const count = pathOr(0, ["count"], data);
    const page = pathOr(1, ["current_page"], data);
    const perPage = pathOr(10, ["per_page"], data);
    const total = pathOr(0, ["total"], data);
    const totalPages = pathOr(0, ["total_pages"], data);
    const files = pathOr([], ["result", "data"], data);

    return {
      count,
      page,
      perPage,
      total,
      totalPages,
      files,
    };
  } catch (error) {
    throw error;
  }
};
export const setAttachment = async (
  resourceName,
  resourceId,
  payload,
  extraHeaders,
  progress = () => {}
) => {
  try {
    const url = generateApiUrl(
      ["globalServices", "keyValueAttachment"],
      [resourceName, resourceId]
    );
    const headers = { "Content-Type": "multipart/form-data", ...extraHeaders };
    const response = await httpService.post(
      url,
      payload,
      headers,
      true,
      progress
    );
    const data = pathOr(null, ["data", "data"], response);
    return { code: pathOr(null, ["code"], data) };
  } catch (error) {
    throw error;
  }
};
